// packages block
import { Controller } from "react-hook-form";
import {
  Button, Col, Form, Input, Label, Modal, ModalBody, ModalFooter,
  ModalHeader, Row,
} from "reactstrap";
// component block
import CustomButton from "../../../../components/layout/CustomButton";
// utils block
import { CUSTOM, DIRECT_HIRE } from "../../../../utils/constant";
import { bodyDefaultData } from "../../../../utils/helper";

export default function ExecutiveAcceptModalEscalation({
  modal,
  toggle,
  executiveAcceptProtocolLoading,
  confirmAction,
  onClosed,
  getValues,
  companyName,
  companyContactName,
  agreementType,
  control,
  errors,
  setValue,
}) {
  const type = agreementType === DIRECT_HIRE ? "Direct Hire" : "Temp";
  let agreementName = agreementType === CUSTOM ? "Agreement" : `${type} Agreement`;

  const subjectDefault = getValues()?.subject
    ? getValues()?.subject
    : `${agreementName} - ${companyName} & RealREPP`;
  const bodyDefault = getValues()?.body
    ? getValues()?.body
    : bodyDefaultData(companyContactName, companyName, type);

  const ExecutiveApprovePreTemplate = () => (
    <Form>
      <Row>
        <Col md="12" sm="12">
          <Label>Subject</Label>
          <Controller
            name="subject"
            control={control}
            defaultValue={subjectDefault}
            rules={{
              required: {
                value: false,
                message: "Email subject is required!",
              },
            }}
            render={({ field }) => (
              <Input
                type="text"
                name={field.name}
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                onBlur={field.onBlur}
                placeholder="Email Subject"
                errMsg={errors?.subject?.message as any}
              />
            )}
          />
        </Col>

        <Col md="12" sm="12" className="mt-3">
          <Label>Body</Label>
          <Controller
            name="body"
            control={control}
            defaultValue={bodyDefault}
            rules={{
              required: {
                value: false,
                message: "Email body is required!",
              },
            }}
            render={({ field }) => (
              <Input
                type="textarea"
                className="email-body"
                name={field.name}
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                onBlur={field.onBlur}
                placeholder="Email Body"
                errMsg={errors?.body?.message as any}
              />
            )}
          />
        </Col>
      </Row>
    </Form>
  );

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      className="for-modal-styling"
      onClosed={onClosed}
      scrollable
    >
      <ModalHeader>Approve - Executive</ModalHeader>
      <ModalBody>
        <div className="approval-content">
          <p>
            Are you sure you want to send this agreement for client's signature?
          </p>
          <p>
            Approve the agreement will results in sending out for executive’s
            then client’s signature.
          </p>
        </div>

        <div>
          <ExecutiveApprovePreTemplate />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={onClosed}
          className="modal-close bg-transparent border-0 text-dark"
        >
          Cancel
        </Button>
        <CustomButton
          buttonType="button"
          buttonText={"Approve"}
          buttonColor={"success"}
          buttonClick={confirmAction}
          loading={executiveAcceptProtocolLoading}
        />
      </ModalFooter>
    </Modal>
  );
}
